import type { FixedHeaderProps } from './fixed-header.interface';
import type { FC } from 'react';

import React from 'react';

export const FixedHeader: FC<FixedHeaderProps> = (props: FixedHeaderProps) => (
  <div className={'form-fixed'}>{props.children}</div>
);
